import { render } from "./Offering.vue?vue&type=template&id=18a9ba72&scoped=true"
import script from "./Offering.vue?vue&type=script&lang=js"
export * from "./Offering.vue?vue&type=script&lang=js"

import "./Offering.vue?vue&type=style&index=0&id=18a9ba72&lang=scss&scoped=true"

import exportComponent from "/Users/hanssagita/Documents/freelance/gunsa2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a9ba72"]])

export default __exports__